import $ from 'jquery';
import EasyPieChart from 'easy-pie-chart';

const createChart = ($element, options) => {
    $element.each(function(){
        let data = $(this).data();
        if(!!options){
            data = {...data,...options};
        }
        return new EasyPieChart(this, data);
    });
}
export default createChart;